import React from "react";

const ResultListHotelPicture = ({ picture: { url, legend }, hotelName }) => (
  <div className="link-photo">
    <img
      src={url}
      alt={legend || `Photo de ${hotelName}`}
      itemProp="image"
      loading="lazy"
    />
  </div>
);

export default ResultListHotelPicture;
